// import * as types from '../types';
import { ActionContext, ActionTree, GetterTree } from "vuex";
import { InspectKbn, SeibiKbn } from "@/model/InspectKbn";
import { InspectStaff } from "@/model/InspectStaff";
import { LiftUse } from "@/model/LiftUse";

export interface InspectionDetailState {
  inspectLine: InspectKbn[];
  liftUse: LiftUse[];
  shakenShurui: SeibiKbn[];
  staffHojo: InspectStaff[];
  staffKensain: InspectStaff[];
  staffSeibishi: InspectStaff[];
  hasData: boolean;
  stateId: number;
  stateNm: string;
  inspectLineCd: string;
  shakenShuruiSeibiMenuCd: string;
  jizen: InspectKbn[];
  jizenCd: string;
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  shakenShuruiNm: string;
  shakenShuruiSeibiMenuUpdatedAt: string;
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
}

const initialState: InspectionDetailState = {
  inspectLine: [],
  liftUse: [],
  shakenShurui: [],
  staffHojo: [],
  staffKensain: [],
  staffSeibishi: [],
  stateId: 0,
  stateNm: "",
  hasData: false,
  inspectLineCd: "",
  shakenShuruiSeibiMenuCd: ""
  , jizen: []
  , jizenCd: ""
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  , shakenShuruiNm: ""
  , shakenShuruiSeibiMenuUpdatedAt: ""
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
};

const actions: ActionTree<InspectionDetailState, any> = {
  setInspectLine(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setInspectLine", payload);
  },
  setLiftUse(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setLiftUse", payload);
  },
  setShakenShurui(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setShakenShurui", payload);
  },
  setStaffHojo(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setStaffHojo", payload);
  },
  setStaffKensain(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setStaffKensain", payload);
  },
  setStaffSeibishi(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setStaffSeibishi", payload);
  },
  save({ commit }: ActionContext<InspectionDetailState, any>): void {
    commit("save");
  },
  setProgressState(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: { stateId: number; stateNm: string }
  ): void {
    commit("setProgressState", payload);
  },
  clearState({ commit }: ActionContext<InspectionDetailState, any>): void {
    commit("clearState");
  },
  setInspectLineCd(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setInspectLineCd", payload);
  },
  setSeibiMenuCd(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setSeibiMenuCd", payload);
  }
  , setJizen(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setJizen", payload);
  }
  , setJizenCd(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setJizenCd", payload);
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  , setShakenShuruiNm(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setShakenShuruiNm", payload);
  }
  , setShakenShuruiSeibiMenuUpdatedAt(
    { commit }: ActionContext<InspectionDetailState, any>,
    payload: any
  ): void {
    commit("setShakenShuruiSeibiMenuUpdatedAt", payload);
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
};

const mutations = {
  setInspectLine(state: InspectionDetailState, payload: InspectKbn[]) {
    state.inspectLine = payload;
  },
  setLiftUse(state: InspectionDetailState, payload: LiftUse[]) {
    state.liftUse = payload;
  },
  setShakenShurui(state: InspectionDetailState, payload: SeibiKbn[]) {
    state.shakenShurui = payload;
  },
  setStaffHojo(state: InspectionDetailState, payload: InspectStaff[]) {
    state.staffHojo = payload;
  },
  setStaffKensain(state: InspectionDetailState, payload: InspectStaff[]) {
    state.staffKensain = payload;
  },
  setStaffSeibishi(state: InspectionDetailState, payload: InspectStaff[]) {
    state.staffSeibishi = payload;
  },
  save(state: InspectionDetailState) {
    state.hasData = true;
  },
  setProgressState(
    state: InspectionDetailState,
    payload: { stateId: number; stateNm: string }
  ) {
    if (payload.stateId) {
      state.stateId = payload.stateId;
      state.stateNm = payload.stateNm;
    }
  },
  clearState(state: InspectionDetailState) {
    Object.assign(state, { ...initialState });
  },
  setInspectLineCd(state: InspectionDetailState, payload: string) {
    state.inspectLineCd = payload;
  },
  setSeibiMenuCd(state: InspectionDetailState, payload: string) {
    state.shakenShuruiSeibiMenuCd = payload;
  }
  , setJizen(state: InspectionDetailState, payload: InspectKbn[]) {
    state.jizen = payload;
  }
  , setJizenCd(state: InspectionDetailState, payload: string) {
    state.jizenCd = payload;
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  , setShakenShuruiNm(state: InspectionDetailState, payload: string) {
    state.shakenShuruiNm = payload;
  }
  , setShakenShuruiSeibiMenuUpdatedAt(state: InspectionDetailState, payload: string) {
    state.shakenShuruiSeibiMenuUpdatedAt = payload;
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
};

const getters: GetterTree<InspectionDetailState, any> = {
  currentState(state: InspectionDetailState) {
    return state;
  },
  getInspectLine(state: InspectionDetailState) {
    const filterData = state.inspectLine.filter(e => e.selected === "1");
    return filterData;
  },
  getLiftUse(state: InspectionDetailState) {
    const filterData = state.liftUse.filter(e => e.selected === "1");
    return filterData;
  },
  getShakenShurui(state: InspectionDetailState) {
    const filterData = state.shakenShurui.filter(e => e.selected === "1");
    return filterData;
  },
  getStaffHojo(state: InspectionDetailState) {
    const filterData = state.staffHojo.filter(e => e.selected === "1");
    return filterData;
  },
  getStaffKensain(state: InspectionDetailState) {
    const filterData = state.staffKensain.filter(e => e.selected === "1");
    return filterData;
  },
  getStaffSeibishi(state: InspectionDetailState) {
    const filterData = state.staffSeibishi.filter(e => e.selected === "1");
    return filterData;
  },
  useLine(state: InspectionDetailState): boolean {
    return (
      state.inspectLineCd != "" &&
      state.inspectLineCd != "0" &&
      state.inspectLineCd != "3"
    ); //3 = no line;
  },
  seibiMenuCd(state: InspectionDetailState) {
    return state.shakenShuruiSeibiMenuCd;
  }
  , getJizen(state: InspectionDetailState) {
    const filterData = state.jizen.filter(e => e.selected === "1");
    return filterData;
  }
  , isDoJizen(state: InspectionDetailState) {
    if (!state.jizenCd) return false;
    return (state.jizenCd == "1");
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  , getShakenShuruiNm(state: InspectionDetailState) {
    return state.shakenShuruiNm;
  }
  , getShakenShuruiSeibiMenuUpdatedAt(state: InspectionDetailState) {
    return state.shakenShuruiSeibiMenuUpdatedAt;
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
};

export default {
  namespaced: true,
  state: { ...initialState },
  getters,
  mutations,
  actions
};
